import React from 'react';
import logoImage from '../assets/logo.png';

interface LogoProps {
  textColor?: string;
}

const Logo: React.FC<LogoProps> = ({ textColor = 'text-dark' }) => {
  return (
    <div className="flex items-center space-x-2">
      <img
        src={logoImage}
        alt="icubechat logo"
        className="w-10 h-10 rounded-lg object-contain"
      />
      <span className={`text-lg md:text-xl font-bold ${textColor} font-inter`}>
        icubechat
      </span>
    </div>
  );
};

export default Logo;
